export class SocketEvent {
    timestamp: number;
    accountMail: string;
    itemType: string;
    eventType: string;
    eventDescription: string;
    sender: string;
    subject: string;
    fragment: string;
    folderName: string;
    targetFolderId: string;
    targetFolderName: string;
    flagName: string;
    name: string;
    oldName: string;
    newName: string;
    senderName: string;
    itemId: number;
    folderId: number;
    flagId: number;
    parentId: number;
    targetId: number;
    conversationId: number;
    affectedMessages: number[];
    isHighPriority: boolean;
    isLowPriority: boolean;
    isDraft: boolean;
    isFromMe: boolean;
    inboxUnreadCount: number;

    constructor(accountMail: string, eventType: string) {
        this.accountMail = accountMail;
        this.eventType = eventType;
    }
}
